<template>
<div class="channel_list_op3">
<!-- 渠道列表logo -->
<Poptip
    popper-class="channel_scan_pop"
    trigger="hover"
    :placement="placement"
    offset="20"
    :transfer="true"
    width="140">
    <i class="iconfont icontupian"></i>
    <div slot="content">
      <img class="scan_img"  :src="rowData.agent_logo_path_url" alt=""/>
    </div>
</Poptip>
</div>
</template>
<script>
export default {
  name: 'channelOpe3',
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  data() {
    return {}
  },
  computed: {
    placement() {
      const totalHeight = document.querySelector('.normal-right-inner-wrap').getBoundingClientRect().height
      if (totalHeight - 138 - 32 - this.index * 32 < 160) {
        if (totalHeight - 138 - 32 - this.index * 32 < 100) {
          return 'right-end'
        } else {
          return 'right'
        }
      } else {
        return 'right-start'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.channel_list_op3 {
  position: relative;
  .iconfont {
    cursor: pointer;
    padding: 10px 10px 10px 0;
  }
}
.scan_img {
  width: 140px;
  height: 140px;
  box-shadow: 0px 2px 8px 4px rgba(135, 150, 176, 0.15);
}
</style>
<style lang="scss">
.channel_scan_pop {
  padding: 0px !important;
  min-width: 140px !important;
  .ivu-poptip-body {
    padding: 0px !important;
  }
}
</style>
